import {
  type EnvironmentSettings,
  getEnvironmentSettings,
  useFetchAppSettings,
} from '@festina-life/authentication'
import { AllServers, notEmpty, type Server } from '@festina-life/core'
import { useMemo } from 'react'

export const ServerConfigurationEntries: Record<
  Server,
  keyof EnvironmentSettings
> = {
  collCalc: 'REACT_APP_COLLCALC_API_ENDPOINT',
  life: 'REACT_APP_LIFE_API_ENDPOINT',
  lifeDataReplicator: 'REACT_APP_LIFEDATAREPLICATOR_API_ENDPOINT',
  unitLink: 'REACT_APP_UNITLINK_API_ENDPOINT',
  unitLinkDataReplicator: 'REACT_APP_UNITLINKDATAREPLICATOR_API_ENDPOINT',
  legalEntity: 'REACT_APP_LEGALENTITY_API_ENDPOINT',
  legalEntityDataReplicator: 'REACT_APP_LEGALENTITYDATAREPLICATOR_API_ENDPOINT',
  moneyIn: 'REACT_APP_MONEYIN_API_ENDPOINT',
  moneyOut: 'REACT_APP_MONEYOUT_API_ENDPOINT',
  configuration: 'REACT_APP_CONFIGURATION_API_ENDPOINT',
  dataMart: 'REACT_APP_DATAMART_API_ENDPOINT',
  dataMart2: 'REACT_APP_DATAMART2_API_ENDPOINT',
}

export const useAvailableServers = () => {
  const { data: appSettings } = useFetchAppSettings()

  return useMemo(() => {
    const [currentConfiguration] = getEnvironmentSettings(appSettings!)

    return AllServers.filter(
      (serverName) =>
        ServerConfigurationEntries[serverName] in currentConfiguration,
    ).filter(notEmpty)
  }, [appSettings])
}
